export const infoCards = [
  {
    color: '#00838f',
    title: 'Latest News',
    info: 'All latest news',
    text: 'Give me the latest news',
  },
  {
    color: '#1565c0',
    title: 'News by Categories',
    info:
      'Business, Entertainment, General, Health, Science, Sports, Technology',
    text: 'Give me the latest Technology news',
  },
  {
    color: '#4527a0',
    title: 'News by Terms',
    info:
      'Bitcoin, PlayStation 5, Smartphones, Donald Trump, Corona Virus, ...',
    text: "What's up with Bitcoin?",
  },
  {
    color: '#283593',
    title: 'News by Sources',
    info:
      'CNN, Wired, BBC News, Time, IGN, Buzzfeed, ABC News, Google News, ...',
    text: 'Give me the news from CNN',
  },
];

export const weatherCards = [
  {
    color: '#5f0f40',
    title: 'Weather Forecast',
    info: 'Rain / Hot / Warm / Cold / Chilly / Cool',
    text: 'Is it going to Rain in USA?',
  },
  {
    color: '#9a031e',
    title: 'Today Forecast',
    info: 'Weather / Temperature / Humidity / Pressure',
    text: 'Tell me the Temperature in USA?',
  },
  {
    color: '#0f4c5c',
    title: 'With Date',
    info: 'Now / Tomorrow',
    text: 'Tell me the Weather in USA on Tomorrow?',
  },
  {
    color: '#fb8b24',
    title: 'Within 5 Days',
    info: 'Sunday / Monday / Tuesday / Wednesday/ Thursday / Friday / Saturday',
    text: 'Tell me the Weather in USA on Saturday?',
  },
];
